<mat-sidenav-container hasBackdrop="false" class="sidenav-full whiteSidenav">
  <mat-sidenav #auditSideNav mode="over" position="end" [(opened)]="auditDetailSidenavOpen" [disableClose]="true">

    <sidenav-content-lead-info-audits-details [audit]="selectedAudit" (close)="auditDetailSidenavOpen = false">
    </sidenav-content-lead-info-audits-details>

  </mat-sidenav>
  <mat-sidenav-content>
    <div class="auditContainer">
      <div class="filtersContainer">

        <mat-form-field appearance="outline">
          <mat-label>Categorie</mat-label>
          <mat-select [formControl]="categoryForm" multiple>
            <mat-option *ngFor="let category of auditsCategories$ | async" [value]="category">
              {{'audit.categories.'+category | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <ng-container *ngFor="let audit of (audits$ | async)! | filterAudits: selectedCategories">
        <div [ngClass]="selectedAudit == audit ? 'highlightSelected' : ''">
          <ng-container appAuditItem [audit]="audit" (selected)="openAuditDetail($event)"
            (unselected)="auditDetailSidenavOpen = false"></ng-container>
        </div>
      </ng-container>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
